const DeliveryRequestStatusEnum = {
    pending: 'Pending Approval',
    out: 'Out For Home',
    accepted: 'Approved',
    done: 'Delivered'
};


export default DeliveryRequestStatusEnum;